import { PlayerAhoyEvent } from "@javascripts/player_ahoy_event";

export default class BannerAdTracker {
  constructor(options = {}) {
    this._data = options.data;
  }

  get data() {
    return this._data
  }

  sendStartEvent(props) {
    this.sendEvent("START", props);
  }

  sendEmptyEvent(props) {
    this.sendEvent("EMPTY", props);
  }

  sendImpressionEvent(props) {
    this.sendEvent("IMPRESSION_VIEWABLE", props);
  }

  sendEvent(ad_event, props = {}) {
    PlayerAhoyEvent.sendPlaybackBannerAd({
      ad_uuid: props.ad_uuid,
      ad_slot: props.ad_slot,
      play_uuid: this.data.playUUID(),
      ad_event: ad_event,
      advertiser_id: props.advertiser_id,
      campaign_id: props.campaign_id,
      creative_id: props.creative_id,
      is_empty: props.is_empty,
      line_item_id: props.line_item_id,
      size: props.size,
      source_agnostic_creative_id: props.source_agnostic_creative_id,
      source_agnostic_line_item_id: props.source_agnostic_line_item_id
    });
  }

  static sendEvent({ ad_event, uuid }) {
    PlayerAhoyEvent.sendPlaybackBannerAd({
      ad_event,
      play_uuid: uuid
    })
  }
}